import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

const navigation = [
	{
		href: '/goods/list',
		name: 'List',
		permission: null
	},
	{
		href: '/goods/categories',
		name: 'Categories',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Goods',
	tabs: navigation,
	permission: null
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/wrap-main.js